/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { useAxios } from "@/hooks";
import { endPoint } from "@/utils";

const useSearchAddress = () => {
    const { fetchData, response }: any = useAxios();

    const handleSearch = async (text: string) => {
        if (text?.trim() === "") return;
        if (text?.trim()?.length > 2) {
            await fetchData({
                url: endPoint.SEARCH_LOCATION_API,
                method: "POST",
                data: {
                    queryString: text,
                },
            });
        }
    };

    const handleAddressSelect = async (placeId: string, onAddressSelect: (address: any) => void) => {
        const addressdata = await fetchData({
            url: endPoint.ADDRESS_LOCATION_API,
            method: "POST",
            data: {
                placeId
            },
        });
        onAddressSelect(addressdata.data);
    }

    return {
        data: response?.data?.predictions || [],
        handleSearch,
        handleAddressSelect,
    };
}

export default useSearchAddress;
